"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesignObjectSchema = exports.DesignObjectTypeSchema = exports.DesignObjectType = void 0;
exports.designObjectKey = designObjectKey;
const zod_1 = require("zod");
var DesignObjectType;
(function (DesignObjectType) {
    DesignObjectType["Net"] = "net";
    DesignObjectType["Module"] = "module";
    DesignObjectType["Component"] = "component";
    DesignObjectType["NetConn"] = "netconn";
    DesignObjectType["Custom"] = "custom";
})(DesignObjectType || (exports.DesignObjectType = DesignObjectType = {}));
exports.DesignObjectTypeSchema = zod_1.z.nativeEnum(DesignObjectType);
const nullToUndefined = (val) => (val === null ? undefined : val);
exports.DesignObjectSchema = zod_1.z.object({
    type: exports.DesignObjectTypeSchema,
    net: zod_1.z.preprocess(nullToUndefined, zod_1.z.string().optional()),
    module: zod_1.z.preprocess(nullToUndefined, zod_1.z.string().optional()),
    component: zod_1.z.preprocess(nullToUndefined, zod_1.z.string().optional()),
    signal: zod_1.z.preprocess(nullToUndefined, zod_1.z.string().optional()),
    customTypeName: zod_1.z.preprocess(nullToUndefined, zod_1.z.string().optional()),
    subjectName: zod_1.z.preprocess(nullToUndefined, zod_1.z.string().optional()),
    description: zod_1.z.preprocess(nullToUndefined, zod_1.z.string().optional()),
    properties: zod_1.z.preprocess(nullToUndefined, zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional()),
});
function designObjectKey(obj) {
    return `${obj.type}|${obj.net ?? ''}|${obj.module ?? ''}|${obj.component ?? ''}|${obj.signal ?? ''}|${obj.customTypeName ?? ''}|${obj.subjectName ?? ''}`;
}
//# sourceMappingURL=DesignObject.js.map